import { ComponentClass } from 'react'
import * as yup from 'yup'
import { reduxForm } from 'redux-form'
import { FORM_REDEMPTION } from 'constants/forms'
import { asyncValidator } from 'helpers/schemaHelpers'
import { shouldAsyncValidate } from 'helpers/formHelpers'
import redemptionSchema from 'schemas/redemptionSchema'

export default <TProps>(Component: ComponentClass<TProps>, schema?: yup.ObjectSchema<any>) => reduxForm({
  form: FORM_REDEMPTION,
  asyncValidate: asyncValidator(schema || redemptionSchema),
  shouldAsyncValidate,
  destroyOnUnmount: !schema,
  forceUnregisterOnUnmount: true,
})(Component)
